import React, { memo } from 'react';
import { DraftsIcon, CogIcon, MiroculusIcon, UsersIcon, Link, } from '@miroculus/nucleo';
import classnames from 'classnames/bind';
import { organizationSettingsUrl } from 'cons/routes';
import { HeadingWithButton } from 'components';
import styles from './Organization.scss';
const cx = classnames.bind(styles);
const QuickInfo = memo(({ memberCount, instrumentCount, protocolCount }) => (React.createElement("div", { className: cx('quick-info') },
    React.createElement("ul", null,
        React.createElement("li", null,
            React.createElement(UsersIcon, null),
            memberCount),
        React.createElement("li", null,
            React.createElement(MiroculusIcon, null),
            instrumentCount),
        React.createElement("li", null,
            React.createElement(DraftsIcon, null),
            protocolCount)))));
QuickInfo.displayName = 'QuickInfo';
const OrganizationHeader = ({ name, orgSlug, memberCount, instrumentCount, protocolCount, canEditOrganization, }) => (React.createElement("section", { key: "organization-header", className: cx('container--header') },
    React.createElement(HeadingWithButton, { title: name, titleAnnex: React.createElement(QuickInfo, { memberCount: memberCount, instrumentCount: instrumentCount, protocolCount: protocolCount }) }),
    React.createElement("div", { className: cx('heading-options') },
        React.createElement("h3", null,
            "ORG ID: ",
            orgSlug),
        canEditOrganization && (React.createElement(Link, { to: organizationSettingsUrl(orgSlug), "data-testid": `org-settings-button-${orgSlug}` },
            React.createElement(CogIcon, null),
            " Admin Settings")))));
export default memo(OrganizationHeader);
